<template>
	<div class="flex flex-row">
		<!-- 全国省市区 -->
		<Left></Left>
		<div class="flex" style="position: relative;">

      <Overview style="position: absolute;left: 0px;top: 0px;z-index: 10;"/>
      <!-- 大区组件 -->
      <SuperMap v-show="adcode" class="superMap" :adcode="adcode"></SuperMap>
      <!-- <SuperMap style="min-width: 2008px;"></SuperMap> -->
      <div class="flex flex-direction" style="position: absolute;right: 0px;top: 0px;">
        <OperationTrend class="margin-bottom-sm"/>
        <OperationPassageway/>
      </div>
    </div>
		<Right></Right>
	</div>
</template>
<script>
// import { formatTime } from '../utils/index.js'
import Left from "@/components/site/left.vue";
import SuperMap from "@/components/superMap.vue";
import Right from "@/components/site/right.vue";

import Overview from "@/components/common/overview";
import OperationTrend from "@/components/common/operationTrend";
import OperationPassageway from "@/components/common/operationPassageway";
export default {
  data () {
    return {
			adcode:''
    };
  },
  components: {
    Left,
    SuperMap,
    Overview,
    OperationTrend,
    OperationPassageway,
    Right
  },
	mounted() {
      if(this.$route.query&&this.$route.query.adcode){
        this.adcode = this.$route.query.adcode;
        this.$EventBus.$emit('update',{district:this.adcode});
      }
	},
};
</script>

<style lang="scss" scoped>
.superMap{
  min-width: 2008px;
}
</style>